// ==============================|| OVERRIDES - INPUT LABEL ||============================== //

import { BackHand } from "@mui/icons-material";

export default function InputLabel(theme) {
  return {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: theme.palette.grey[500],
          overflow: "visible",
          lineHeight: "1.4375em",
        },
        outlined: {
          lineHeight: '1.4375em',
          overflow: "visible",
          '&.MuiInputLabel-sizeSmall': {
            lineHeight: '1.4375em',
            overflow: "visible",
          },
          '&.MuiInputLabel-shrink': {
            padding: '0 2px',
            lineHeight: '1.4375em',
            overflow: "visible",
          }
        }
      }
    }
  };
}
